import Slider from "react-slick";

const About = () => {
  const sliderSettings = {
    dots: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="about">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="title">
              <h3 className="fade-in-left">Rólunk mondták</h3>
            </div>
          </div>
        </div>
        <div className="row">
          <Slider {...sliderSettings}>
            <div className="card">
              <div className="card__image">
                <img
                  src="/images/signowise-hu/kisfalvi_bence.jpeg"
                  alt="kisflavi bence"
                />
              </div>
              <div className="card__icon">
                <img src="/images/signowise-hu/icon-otp-two.png" alt="OTP" />
              </div>
              <div className="card__text">
                <p className="card__text--name">Kisfalvi Bence</p>
                <p className="card__text--description">
                  Üzletfejlesztési Igazgató
                </p>
                <span className="card__text--icon" />
                <p className="card__text--quote-style">
                  A Cursor Insight csapata határidőre leszállította a kritikus
                  banki rendszernek minősülő SignoWise biometrikus e-aláírási
                  megoldást, amit azóta is közel 400 fiókunkban használunk.
                </p>
              </div>
            </div>
            <div className="card">
              <div className="card__image">
                <img
                  src="/images/signowise-hu/erdosi_peter.jpeg"
                  alt="erdősi péter"
                />
              </div>
              <div className="card__icon">
                <p>Magyar Elektronikus Aláírás Szövetség</p>
              </div>
              <div className="card__text">
                <p className="card__text--name">Erdősi Péter</p>
                <p className="card__text--description">Alelnök</p>
                <span className="card__text--icon" />
                <p className="card__text--quote-style">
                  A SignoWise a biometrikus aláírás és a PKI technológia
                  kombinációjával egy praktikusan használható e-aláírási
                  megoldást alkot.
                </p>
              </div>
            </div>
            <div className="card">
              <div className="card__image">
                <img
                  src="/images/signowise-hu/bodnar_balazs.jpeg"
                  alt="bodnár balázs"
                />
              </div>
              <div className="card__icon">
                <img src="/images/signowise-hu/icon-otp.png" alt="OTP" />
              </div>
              <div className="card__text">
                <p className="card__text--name">Bodnár Balázs</p>
                <p className="card__text--description">Back Office Vezető</p>
                <span className="card__text--icon" />
                <p className="card__text--quote-style">
                  A SignoWise-zal már évek óta megbízhatóan írnak alá ingatlan
                  közvetítőink és ügyfeleink a terepen, összesen közel 1000
                  darab tableten.
                </p>
              </div>
            </div>
            <div className="card">
              <div className="card__image">
                <img
                  src="/images/signowise-hu/dajka_viktor.png"
                  alt="Dajka Viktor"
                />
              </div>
              <div className="card__icon">
                <img src="/images/signowise-hu/icon-andoc.png" alt="Andoc" />
              </div>
              <div className="card__text">
                <p className="card__text--name">Dajka Viktor</p>
                <p className="card__text--description">Operatív Igazgató</p>
                <span className="card__text--icon" />
                <p className="card__text--quote-style">
                  A SignoWise integrációja az Andoc dokumentumkezelő rendszerhez
                  gyors és problémamentes volt.
                </p>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default About;
